import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();
export const getNotifications = (params: any) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/notifications",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateNotifications = (data: any) => {
  return axios({
    method: "PUT",
    url: "/notifications",
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateSingleNotification = (data: any, notificationId: number | string) => {
  return axios({
    method: "PUT",
    url: `/notifications/${notificationId}`,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const clearAllReadNotifications = () => {
  return axios({
    method: "DELETE",
    url: `/notifications`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};